import { Component } from '@angular/core';
import { IntlService } from '@progress/kendo-angular-intl';
import { MessageService } from '@progress/kendo-angular-l10n';
import { CustomMessagesService } from 'src/app/services/custom-messages.service';
import { ApiService } from 'src/app/services/http/api.service';
import { BaseHttpResponse } from 'src/app/models/base-http-response';
import { DashboardIV } from 'src/app/models/dasboardIV.model';
import { Site } from 'src/app/models/site.model';

@Component({
  selector: 'app-dashboard-iv-component',
  templateUrl: './dashboard-iv.component.html'
})
export class DashboardIVComponent {
  public listItemsLocais: Array<Site> = [];
  public data: DashboardIV = {
    numeroArmarios: 0,
    numeroLocais: 0,
    numeroEquipas: 0,
    numeroUtilizadores: 0,
    numeroArtigos: 0,
    numeroCentrosDeCusto: 0,
    numeroCacifosComAnomalia: 0,
    numeroCacifosInibidos: 0,
    numeroCacifosStockBaixo: 0,
  };
  public pieChartData: Array<any> = [];
  public placeHolder: any = {
    nome: '',
    id: undefined,
  };
  public isLoading: boolean = false;

  public customMsgService: CustomMessagesService;

  constructor(public intl: IntlService, public messages: MessageService, private api: ApiService) {
    this.customMsgService = this.messages as CustomMessagesService;
    this.placeHolder.nome = this.customMsgService.translate('escolherLocal');
    this.api
    .getRequest<BaseHttpResponse<Site[]>>("Local/GetLocais")
    .then((data) => {
        this.listItemsLocais = data.value;
    })
    .catch((err) => { });
this.customMsgService = this.messages as CustomMessagesService;
    this.load(undefined);
  }

  public selectionChange(value: Site): void {
    this.load(value.id);
  }

  load(idLocal: number | undefined) {
    this.isLoading = true;
    let endpoint = idLocal == undefined ? "Dashboard/GetDadosIV" : `Dashboard/GetDadosIV?idLocal=${idLocal}`;
    this.api
      .getRequest<BaseHttpResponse<DashboardIV>>(endpoint)
      .then((response) => {
        this.data = response.value;
        this.updatePieChartData();
        this.isLoading = false;
      })
      .catch(() => {
        this.isLoading = false;
      });

  }

  updatePieChartData(): void {
    // Adicionando os dados do gráfico com rótulos e valores
    this.pieChartData = [
      { category: this.customMsgService.translate('cacifosComStockBaixo'), value: this.data.numeroCacifosStockBaixo },
      { category: this.customMsgService.translate('cacifosComAnomalia'), value: this.data.numeroCacifosComAnomalia },
      { category: this.customMsgService.translate('cacifosInibidos'), value: this.data.numeroCacifosInibidos },
    ];
  }
}